import type { EventStatus } from '@/types/event.types';

/** The natural next step of the lifecycle (primary button) */
export const NEXT_STATUS: Partial<Record<EventStatus, EventStatus>> = {
  DRAFT: 'OPEN',
  OPEN: 'CLOSED',
  CLOSED: 'COMPLETED',
};

/** Button / dialog title for moving `from` → `to` */
export function statusActionLabel(from: EventStatus, to: EventStatus): string {
  if (to === 'OPEN') return from === 'CLOSED' ? 'Reabrir inscripciones' : 'Abrir inscripciones';
  if (to === 'CLOSED') return 'Cerrar inscripciones';
  if (to === 'COMPLETED') return 'Marcar como completado';
  return 'Volver a borrador';
}

export const NO_PERMISSION_HINT = 'No tiene permiso para cambiar el estado del evento';
